import { ReactNavigationInteractor } from '../adapter/real/ReactNavigationInteractor';
import { NavigationInteractor } from '../domain/gateways/Navigation.interactor';

export class NavigationContextFactory {
  static navigationInteractor(): NavigationInteractor {
    return new ReactNavigationInteractor();
  }
}
